/*
 * @Editor: chenqy
 * @Description: 自定义提示/高亮等功能
 * @Date: 2023-03-13 09:31:25
 * @LastEditors: Chenqy
 * @LastEditTime: 2023-08-09 17:04:20
 */

// python语言基本配置
let pythonConfig = {
  comments: {
    lineComment: "#",
    blockComment: ["'''", "'''"],
  },
  brackets: [
    ["{", "}"],
    ["[", "]"],
    ["(", ")"],
  ],
  autoClosingPairs: [
    {
      open: "{",
      close: "}",
    },
    {
      open: "[",
      close: "]",
    },
    {
      open: "(",
      close: ")",
    },
    {
      open: '"',
      close: '"',
      notIn: ["string"],
    },
    {
      open: "'",
      close: "'",
      notIn: ["string", "comment"],
    },
  ],
  surroundingPairs: [
    {
      open: "{",
      close: "}",
    },
    {
      open: "[",
      close: "]",
    },
    {
      open: "(",
      close: ")",
    },
    {
      open: '"',
      close: '"',
    },
    {
      open: "'",
      close: "'",
    },
  ],
  onEnterRules: [
    {
      beforeText: new RegExp(
        "^\\s*(?:def|class|for|if|elif|else|while|try|with|finally|except|async).*?:\\s*$"
      ),
      action: { indentAction: 1 },
    },
  ],
  folding: {
    offSide: true,
    markers: {
      start: new RegExp("^\\s*#region\\b"),
      end: new RegExp("^\\s*#endregion\\b"),
    },
  },
};
let pythonLanguage = {
  defaultToken: "",
  tokenPostfix: ".python",

  keywords: [
    "False", // promoted to keyword.kwlist in Python 3
    "None", // promoted to keyword.kwlist in Python 3
    "True", // promoted to keyword.kwlist in Python 3
    "and",
    "as",
    "assert",
    "async", // new in Python 3
    "await", // new in Python 3
    "break",
    "class",
    "continue",
    "def",
    "del",
    "elif",
    "else",
    "except",
    "exec", // Python 2, but not 3.
    "finally",
    "for",
    "from",
    "global",
    "if",
    "import",
    "in",
    "is",
    "lambda",
    "nonlocal", // new in Python 3
    "not",
    "or",
    "pass",
    "print", // Python 2, but not 3.
    "raise",
    "return",
    "try",
    "while",
    "with",
    "yield",

    "int",
    "float",
    "long",
    "complex",
    "hex",

    "abs",
    "all",
    "any",
    "apply",
    "basestring",
    "bin",
    "bool",
    "buffer",
    "bytearray",
    "callable",
    "chr",
    "classmethod",
    "cmp",
    "coerce",
    "compile",
    "complex",
    "delattr",
    "dict",
    "dir",
    "divmod",
    "enumerate",
    "eval",
    "execfile",
    "file",
    "filter",
    "format",
    "frozenset",
    "getattr",
    "globals",
    "hasattr",
    "hash",
    "help",
    "id",
    "input",
    "intern",
    "isinstance",
    "issubclass",
    "iter",
    "len",
    "locals",
    "list",
    "map",
    "max",
    "memoryview",
    "min",
    "next",
    "object",
    "oct",
    "open",
    "ord",
    "pow",
    "print",
    "property",
    "reversed",
    "range",
    "raw_input",
    "reduce",
    "reload",
    "repr",
    "reversed",
    "round",
    "self",
    "set",
    "setattr",
    "slice",
    "sorted",
    "staticmethod",
    "str",
    "sum",
    "super",
    "tuple",
    "type",
    "unichr",
    "unicode",
    "vars",
    "xrange",
    "zip",

    "__dict__",
    "__methods__",
    "__members__",
    "__class__",
    "__bases__",
    "__name__",
    "__mro__",
    "__subclasses__",
    "__init__",
    "__import__",
  ],
  brackets: [
    {
      open: "{",
      close: "}",
      token: "delimiter.curly",
    },
    {
      open: "[",
      close: "]",
      token: "delimiter.bracket",
    },
    {
      open: "(",
      close: ")",
      token: "delimiter.parenthesis",
    },
  ],
  tokenizer: {
    root: [
      {
        include: "@whitespace",
      },
      {
        include: "@numbers",
      },
      {
        include: "@strings",
      },
      [/[,:;]/, "delimiter"],
      [/[{}\[\]()]/, "@brackets"],

      [/@[a-zA-Z_]\w*/, "tag"],
      [
        /[a-zA-Z_]\w*/,
        {
          cases: {
            "@keywords": "keyword",
            "@default": "identifier",
          },
        },
      ],
    ],

    // Deal with white space, including single and multi-line comments
    whitespace: [
      [/\s+/, "white"],
      [/(^#.*$)/, "comment"],
      [/'''/, "string", "@endDocString"],
      [/"""/, "string", "@endDblDocString"],
    ],
    endDocString: [
      [/[^']+/, "string"],
      [/\\'/, "string"],
      [/'''/, "string", "@popall"],
      [/'/, "string"],
    ],
    endDblDocString: [
      [/[^"]+/, "string"],
      [/\\"/, "string"],
      [/"""/, "string", "@popall"],
      [/"/, "string"],
    ],

    // Recognize hex, negatives, decimals, imaginaries, longs, and scientific notation
    numbers: [
      [/-?0x([abcdef]|[ABCDEF]|\d)+[lL]?/, "number.hex"],
      [/-?(\d*\.)?\d+([eE][+\-]?\d+)?[jJ]?[lL]?/, "number"],
    ],

    // Recognize strings, including those broken across lines with \ (but not without)
    strings: [
      [/'$/, "string.escape", "@popall"],
      [/'/, "string.escape", "@stringBody"],
      [/"$/, "string.escape", "@popall"],
      [/"/, "string.escape", "@dblStringBody"],
    ],
    stringBody: [
      [/[^\\']+$/, "string", "@popall"],
      [/[^\\']+/, "string"],
      [/\\./, "string"],
      [/'/, "string.escape", "@popall"],
      [/\\$/, "string"],
    ],
    dblStringBody: [
      [/[^\\"]+$/, "string", "@popall"],
      [/[^\\"]+/, "string"],
      [/\\./, "string"],
      [/"/, "string.escape", "@popall"],
      [/\\$/, "string"],
    ],
  },
};
// 编辑器提示实例
let completionItemProviderInstances = {};
// 高亮提示
let monarchTokensProviderInstances = {};
// hover提示
let hoverProviderInstances = {};

function getCompletionprovide(code, provideCompletionItems) {
  if (dsf.isArray(provideCompletionItems)) {
    let suggestions = [];
    // 获取最后输入的字符
    // let lastCodes = code.trim().split(" ").slice(-1);
    // let lastCodes = code.trim().replace(/[\s\S]+(?<=[;\s])/, "");
    // 兼容低版本浏览器
    let lastCodes = code.trim().replace(/[\s\S]+[ ;]+([\s\S]+)/, "");
    let codeList = lastCodes.split(".");
    const lastCode = codeList.splice(-1);
    // let matchNameObj = null; // 是否对name进行过匹配
    // 获取提示消息
    const getSuggestions = (levels, filter) => {
      let list = []; // 捕获的到下拉值
      function forEachBreadth(data, index = 0) {
        let searchIndex = -1; // 当前层级匹配到下标
        for (let i = 0; i < data.length; i++) {
          if (data[i].value == levels[index] || data[i].name == levels[index]) {
            searchIndex = i;
            list = data[i].children || [];
            // if (!matchNameObj && ) {
            //   matchNameObj = {
            //     name: data[i].name,
            //     value: data[i].value,
            //     level: index,
            //   };
            // }
            break;
          } else {
            list = [];
          }
        }
        if (searchIndex !== -1 && !dsf.isUnDef(levels[index + 1])) {
          forEachBreadth(data[searchIndex].children, index + 1);
        }
      }
      if (levels.length === 0) {
        list = provideCompletionItems;
      } else {
        forEachBreadth(provideCompletionItems);
      }
      if (list.length) {
        // const reg = new RegExp(filter ? `[${filter}]` : "", "gi");
        for (let i = 0; i < list.length; i++) {
          const { name, value, type, detail } = list[i];
          // if (reg.test(list[i].name)) {
          suggestions.push({
            label: name,
            kind: monaco.languages.CompletionItemKind[type || "Function"],
            insertText: `${value}${type === "Function" ? "()" : ""}`,
            detail: detail,
            filterText: name.replace(/[\u4e00-\u9fa5\w]/g, "$&-"),
            sortText: "1",
            // command: {
            //   id: "editor.suggest",
            //   title: "editor.suggest",
            //   arguments: [name, value],
            // },
          });
          // }
        }
      }
    };
    if (codeList.length !== 0) {
      getSuggestions(codeList, lastCode[0]);
    } else {
      getSuggestions([], lastCode[0]);
    }
    return {
      suggestions,
      // matchNameObj,
    };
  } else {
    return {
      suggestions: [],
      // matchNameObj: null,
    };
  }
}
/**
 * @description: 注册语言
 * @param {*} language 语言种类
 * @param {*} theme 主题
 * @param {*} languageConfig 语言配置项
 * @return {*}
 */
export const monacoRegisterLanguage = (language, languageConfig = {}) => {
  // 注册语言
  monaco.languages.register({
    id: language,
  });
  // 语言配置项
  if (language === "customPython") {
    languageConfig.config = pythonConfig;
    languageConfig.language = pythonLanguage;
  }
  // 自动补全
  monaco.languages.setLanguageConfiguration(language, languageConfig.config);
  // 高亮代码
  monarchTokensProviderInstances[
    language
  ] = monaco.languages.setMonarchTokensProvider(
    language,
    languageConfig.language
  );
};

// 注册代码提示----local
export const completionItemProviderForLocal = (
  completionItems,
  languages,
  customCompletionItemFn
) => {
  if (completionItems && languages.length) {
    // 注销之前的提示
    if (dsf.isEmptyObject(completionItemProviderInstances)) {
      _.map(
        Object.keys(completionItemProviderInstances),
        (completionInstance) => {
          completionItemProviderInstances[completionInstance]?.dispose();
        }
      );
    }
    // 提示逻辑
    const provideCompletionItems = (model, position) => {
      // 获取当前的字符内容
      const range = {
        startLineNumber: position.lineNumber,
        startColumn: 1,
        endLineNumber: position.lineNumber,
        endColumn: position.column,
      };
      let code = model.getValueInRange(range);
      // 自定义
      if (customCompletionItemFn && dsf.isFunction(customCompletionItemFn)) {
        const { suggestions } = customCompletionItemFn(model, position, code);
        return {
          suggestions,
        };
      } else {
        const { suggestions } = getCompletionprovide(code, completionItems);
        // 在非使用enter或者mousedown选择提示项时,自动替换成真实值
        // if (suggestions.length && matchNameObj) {
        //   let replaceRealValue = "";
        //   const reg1 = new RegExp(`(\\s+)${matchNameObj.name}\\.(\\s+)`);
        //   const reg2 = new RegExp(`^${matchNameObj.name}\\.(\\s+|$)`);
        //   const reg3 = new RegExp(`(\\s+)${matchNameObj.name}\\.$`);
        //   if (reg1.test(code)) {
        //     replaceRealValue = code.replace(reg1, `$1${matchNameObj.value}$2`);
        //   } else if (reg2.test(code)) {
        //     replaceRealValue = code.replace(reg2, `${matchNameObj.value}$1`);
        //   } else if (reg3.test(code)) {
        //     replaceRealValue = code.replace(reg3, `$1${matchNameObj.value}`);
        //   }
        //   if (replaceRealValue) {
        //     model.pushEditOperations(
        //       [],
        //       [{ forceMoveMarkers: true, range, text: replaceRealValue }]
        //     );
        //   }
        // }
        return {
          suggestions,
        };
      }
    };
    _.forEach(languages, (language) => {
      completionItemProviderInstances[
        language
      ] = monaco.languages.registerCompletionItemProvider(language, {
        provideCompletionItems,
        // .也能触发补全功能
        triggerCharacters: [".", "@", "#"],
      });
    });
  }
};
// 注册代码提示----jupyter
export const completionItemProviderForJupyter = (jupyterWs, languages) => {
  _.forEach(languages, (language) => {
    completionItemProviderInstances[
      language
    ] = monaco.languages.registerCompletionItemProvider(language, {
      provideCompletionItems: () => {
        // TODO
      },
      // .也能触发补全功能
      triggerCharacters: ["."],
    });
  });
};
// 注册hover提示
export const hoverProvider = (languages, hoverCb) => {
  _.forEach(languages, (language) => {
    hoverProviderInstances[language] = monaco.languages.registerHoverProvider(
      language,
      {
        provideHover: (model, position) => {
          // 获取当前的字符内容
          let code = model.getLineContent(position.lineNumber);
          const contents = hoverCb(model, position, code);
          return contents;
        },
      }
    );
  });
};
// 注销代码提示
export const disposeCompletionItemProvider = (languages) => {
  if (languages) {
    _.map(languages, (language) => {
      if (monarchTokensProviderInstances[language]) {
        completionItemProviderInstances[language]?.dispose();
        completionItemProviderInstances[language] = null;
      }
    });
  } else {
    _.map(Object.keys(completionItemProviderInstances), (language) => {
      if (completionItemProviderInstances[language]) {
        completionItemProviderInstances[language]?.dispose();
        completionItemProviderInstances[language] = null;
      }
    });
  }
};
// 注销高亮提示
export const disposeMonarchTokensProvider = (languages) => {
  if (languages) {
    _.map(languages, (language) => {
      if (monarchTokensProviderInstances[language]) {
        monarchTokensProviderInstances[language]?.dispose();
        monarchTokensProviderInstances[language] = null;
      }
    });
  } else {
    _.map(Object.keys(monarchTokensProviderInstances), (language) => {
      if (monarchTokensProviderInstances[language]) {
        monarchTokensProviderInstances[language]?.dispose();
        monarchTokensProviderInstances[language] = null;
      }
    });
  }
};
// 注销所有注册过的providers
export const disposeAllProviders = () => {
  // 销毁自定义提示
  for (let provider in completionItemProviderInstances) {
    completionItemProviderInstances[provider]?.dispose();
    completionItemProviderInstances[provider] = null;
  }
  // 销毁自定义高亮
  for (let provider in monarchTokensProviderInstances) {
    monarchTokensProviderInstances[provider]?.dispose();
    monarchTokensProviderInstances[provider] = null;
  }
  // 销毁hover提示
  for (let provider in hoverProviderInstances) {
    hoverProviderInstances[provider]?.dispose();
    hoverProviderInstances[provider] = null;
  }
};
